// Mock data pour IZI Travels

export const destinations = [
  // Destinations Nationales (RD Congo)
  {
    id: 1,
    name: 'Kinshasa',
    country: 'RD Congo',
    image: 'https://images.unsplash.com/photo-1729006122953-e3cafd3dd875?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHwzfHxLaW5zaGFzYXxlbnwwfHx8fDE3NzkyODc5MTF8MA&ixlib=rb-4.1.0&q=85',
    category: 'national',
    flag: '🇨🇩',
    gradient: 'from-blue-600 to-yellow-500'
  },
  {
    id: 2,
    name: 'Lubumbashi',
    country: 'RD Congo',
    image: 'https://customer-assets.emergentagent.com/job_izi-travels-preview/artifacts/othtpqs6_lubumbashi.jpg',
    category: 'national',
    flag: '🇨🇩'
  },
  {
    id: 3,
    name: 'Kisangani',
    country: 'RD Congo',
    image: 'https://customer-assets.emergentagent.com/job_izi-travels-preview/artifacts/dp9sbigp_kisangani.jpg',
    category: 'national',
    flag: '🇨🇩'
  },
  {
    id: 4,
    name: 'Goma',
    country: 'RD Congo',
    image: 'https://customer-assets.emergentagent.com/job_izi-travels-preview/artifacts/9wg59sdr_goma.jpg',
    category: 'national',
    flag: '🇨🇩'
  },

  // Destinations Africaines
  {
    id: 5,
    name: 'Johannesburg',
    country: 'Afrique du Sud',
    image: 'https://images.unsplash.com/photo-1636706519609-988babca3dd5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwxfHxKb2hhbm5lc2J1cmd8ZW58MHx8fHwxNzc5Mjg3OTExfDA&ixlib=rb-4.1.0&q=85',
    category: 'african',
    flag: '🇿🇦'
  },
  {
    id: 6,
    name: 'Le Cap',
    country: 'Afrique du Sud',
    image: 'https://images.unsplash.com/photo-1580060839134-75a5edca2e99?w=800&q=80',
    category: 'african',
    flag: '🇿🇦'
  },
  {
    id: 7,
    name: 'Nairobi',
    country: 'Kenya',
    image: 'https://images.pexels.com/photos/36964425/pexels-photo-36964425.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    category: 'african',
    flag: '🇰🇪'
  },
  {
    id: 8,
    name: 'Accra',
    country: 'Ghana',
    image: 'https://customer-assets.emergentagent.com/job_izi-travels-preview/artifacts/f5nuscaa_accra.jpg',
    category: 'african',
    flag: '🇬🇭'
  },
  {
    id: 9,
    name: 'Dar es Salaam',
    country: 'Tanzanie',
    image: 'https://images.unsplash.com/photo-1572252009286-268acec5ca0a?w=800&q=80',
    category: 'african',
    flag: '🇹🇿'
  },
  {
    id: 10,
    name: 'Addis-Abeba',
    country: 'Éthiopie',
    image: 'https://customer-assets.emergentagent.com/job_izi-travels-preview/artifacts/9jy3yok3_addisabeba.jpg',
    category: 'african',
    flag: '🇪🇹'
  },
  {
    id: 11,
    name: 'Lagos',
    country: 'Nigeria',
    image: 'https://images.unsplash.com/photo-1618828665011-0abd973f7bb8?w=800&q=80',
    category: 'african',
    flag: '🇳🇬'
  },
  {
    id: 12,
    name: 'Casablanca',
    country: 'Maroc',
    image: 'https://plus.unsplash.com/premium_photo-1697729894473-f42211860691?w=800&q=80',
    category: 'african',
    flag: '🇲🇦'
  },

  // Destinations Internationales
  {
    id: 13,
    name: 'Paris',
    country: 'France',
    image: 'https://images.unsplash.com/photo-1502602898657-3e91760cbb34?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHwzfHxQYXJpc3xlbnwwfHx8fDE3NzkyODc5NDR8MA&ixlib=rb-4.1.0&q=85',
    category: 'international',
    flag: '🇫🇷'
  },
  {
    id: 14,
    name: 'Londres',
    country: 'Royaume-Uni',
    image: 'https://images.unsplash.com/photo-1513635269975-59663e0ac1ad?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwxfHxMb25kb258ZW58MHx8fHwxNzc5Mjg3OTQ0fDA&ixlib=rb-4.1.0&q=85',
    category: 'international',
    flag: '🇬🇧'
  },
  {
    id: 15,
    name: 'Dubaï',
    country: 'Émirats Arabes Unis',
    image: 'https://images.pexels.com/photos/34025535/pexels-photo-34025535.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    category: 'international',
    flag: '🇦🇪'
  },
  {
    id: 16,
    name: 'Istanbul',
    country: 'Turquie',
    image: 'https://images.unsplash.com/photo-1527838832700-5059252407fa?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzF8MHwxfHNlYXJjaHwzfHxJc3RhbmJ1bHxlbnwwfHx8fDE3NzkyODc5NDR8MA&ixlib=rb-4.1.0&q=85',
    category: 'international',
    flag: '🇹🇷'
  },
  {
    id: 17,
    name: 'Bruxelles',
    country: 'Belgique',
    image: 'https://images.unsplash.com/photo-1573995890753-a4f23342db17?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzF8MHwxfHNlYXJjaHw0fHxCcnVzc2Vsc3xlbnwwfHx8fDE3NzkyODc5NDR8MA&ixlib=rb-4.1.0&q=85',
    category: 'international',
    flag: '🇧🇪'
  },
  {
    id: 18,
    name: 'New York',
    country: 'États-Unis',
    image: 'https://images.unsplash.com/photo-1568515387631-8b650bbcdb90?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHwxfHxNYW5oYXR0YW58ZW58MHx8fHwxNzc5Mjg3OTc4fDA&ixlib=rb-4.1.0&q=85',
    category: 'international',
    flag: '🇺🇸'
  },
  {
    id: 19,
    name: 'Pékin',
    country: 'Chine',
    image: 'https://images.unsplash.com/photo-1547981609-4b6bfe67ca0b?w=800&q=80',
    category: 'international',
    flag: '🇨🇳'
  },
  {
    id: 20,
    name: 'Guangzhou',
    country: 'Chine',
    image: 'https://images.unsplash.com/photo-1602940659805-770d1b3b9911?w=800&q=80',
    category: 'international',
    flag: '🇨🇳'
  }
];

// Compagnies aériennes avec couleurs de marque et codes pays
export const airlines = [
  { id: 1, name: 'Ethiopian Airlines', code: 'ET', country: 'Éthiopie', flag: '🇪🇹', color: '#1B5E20', accent: '#FBC02D' },
  { id: 2, name: 'Kenya Airways', code: 'KQ', country: 'Kenya', flag: '🇰🇪', color: '#C62828', accent: '#2E7D32' },
  { id: 3, name: 'Air France', code: 'AF', country: 'France', flag: '🇫🇷', color: '#002157', accent: '#E2001A' },
  { id: 4, name: 'Brussels Airlines', code: 'SN', country: 'Belgique', flag: '🇧🇪', color: '#0A2845', accent: '#D71920' },
  { id: 5, name: 'Turkish Airlines', code: 'TK', country: 'Turquie', flag: '🇹🇷', color: '#C70039', accent: '#FFFFFF' },
  { id: 6, name: 'Emirates', code: 'EK', country: 'Émirats Arabes Unis', flag: '🇦🇪', color: '#D71921', accent: '#000000' },
  { id: 7, name: 'Qatar Airways', code: 'QR', country: 'Qatar', flag: '🇶🇦', color: '#5C0934', accent: '#FFFFFF' },
  { id: 8, name: 'RwandAir', code: 'WB', country: 'Rwanda', flag: '🇷🇼', color: '#00A1DE', accent: '#FAD201' },
  { id: 9, name: 'Congo Airways', code: '8Z', country: 'RD Congo', flag: '🇨🇩', color: '#007FFF', accent: '#FFD700' },
  { id: 10, name: 'ASKY Airlines', code: 'KP', country: 'Togo', flag: '🇹🇬', color: '#006A4E', accent: '#FFD700' },
  { id: 11, name: 'Air Côte d\'Ivoire', code: 'HF', country: 'Côte d\'Ivoire', flag: '🇨🇮', color: '#F77F00', accent: '#009E60' },
  { id: 12, name: 'TAAG Angola', code: 'DT', country: 'Angola', flag: '🇦🇴', color: '#CE1126', accent: '#000000' }
];

export const services = [
  {
    id: 1,
    title: 'Réservation de billets d\'avion',
    description: 'Réservez vos billets nationaux et internationaux en toute simplicité',
    icon: 'Plane'
  },
  {
    id: 2,
    title: 'Voyages nationaux et internationaux',
    description: 'Accédez à toutes les destinations du monde entier',
    icon: 'Globe'
  },
  {
    id: 3,
    title: 'Assistance voyage',
    description: 'Un accompagnement personnalisé à chaque étape de votre voyage',
    icon: 'Headphones'
  },
  {
    id: 4,
    title: 'Conseils et accompagnement',
    description: 'Des experts à votre écoute pour planifier votre voyage parfait',
    icon: 'Users'
  },
  {
    id: 5,
    title: 'Réservations rapides',
    description: 'Un processus de réservation simple et efficace',
    icon: 'Clock'
  },
  {
    id: 6,
    title: 'Service client réactif',
    description: 'Disponibles 7j/7 pour répondre à vos questions',
    icon: 'MessageCircle'
  }
];
